import { HeaderChangeAction } from './../../../core/store/general/actions';
import { environment } from './../../../../environments/environment';
import { SharedContainer } from './../../shared.container';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './404.component.html',
  styleUrls: ['./404.component.css']
})
export class NotFoundComponent implements OnInit {


  constructor(protected sharedContainer: SharedContainer, protected router: Router) { }


  ngOnInit() {
    this.sharedContainer.generalState$.dispatch(new HeaderChangeAction(1, {headerType: 'home'}));
    this.router.navigate(['/']);
    location.href = '#';
   }

}
